module.exports = __webpack_public_path__ + "assets/img/3e28c8f9493e9246ea90eb48dff6c686.svg";